export default __webpack_public_path__ + "14abd24a8c146d9b802506ca06d80279.svg";